import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { EoDropdownComponent } from '../eo-dropdown/eo-dropdown.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IHttpData, STATUS } from '../../common/use-loading.model';
import { Specialty } from './specialty.model';
import { EoSpecialtyDropdownService } from './eo-specialty-dropdown.service';

@Component({
  selector: 'eo-specialty-dropdown',
  templateUrl: './eo-specialty-dropdown.component.html',
  styleUrl: './eo-specialty-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoSpecialtyDropdownComponent),
      multi: true,
    },
  ],
})
export class EoSpecialtyDropdownComponent
  extends EoDropdownComponent<Specialty>
  implements OnInit, IHttpData<Specialty[]>
{
  @Input() override label = 'Ειδικότητα';
  @Input() override optionLabel = 'SpecialtyName';
  @Input() url: string = 'v1/Specialties';

  override httpData$ = this.specialtyService.specialties$;
  override httpStatus$ = this.specialtyService.status$;
  override httpError$ = this.specialtyService.error$;

  override fetchData(): void {
    this.specialtyService.getSpecialties(this.url).subscribe();
  }

  constructor(private specialtyService: EoSpecialtyDropdownService) {
    super();
  }

  override ngOnInit(): void {
    this.fetchData();
    this.subscriptions = [...this.subscriptions, this.onHttpStatusChange()];
  }

  onHttpStatusChange() {
    return this.httpStatus$.subscribe((status) => {
      switch (status) {
        case STATUS.loading:
          this.loading = true;
          break;
        default:
          this.loading = false;
      }
    });
  }
}
